module.exports = __webpack_public_path__ + "static/img/setting2.eb6e423.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/setting2.png
// module id = b4G+
// module chunks = 24